import React, { useMemo } from 'react';
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box
} from '@mui/material';

const labelMap = {
  totalSumInsured: 'Sum Insured',
  fireFloaterOccupancy: 'Occupancy',
};

const FireFloaterChangesTable = ({ fireFloaterChanges = [] }) => {

 

  const rows = useMemo(() => {
    if (!Array.isArray(fireFloaterChanges)) return [];

    return fireFloaterChanges.flatMap((item) => {
      const key = Object.keys(item)[0];
      const values = item[key];

      if (!values) return [];

      return [{
        field: labelMap[key] || key,
        oldValue: values.oldValue ?? '-',
        newValue: values.newValue ?? '-',
      }];
    });
  }, [fireFloaterChanges]);

  if (!rows.length) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
      }}
    >
      {/* Table */}
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#5569ff', color: '#fff',
          px: '8px',
          py: '4px', }}>
            <TableCell sx={{color: '#fff',fontWeight:'normal' }}>Field Name</TableCell>
            <TableCell sx={{ color: '#fff',fontWeight:'normal' }}>Old Value</TableCell>
            <TableCell sx={{ color: '#fff',fontWeight:'normal' }}>New Value</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.field}</TableCell>
              <TableCell>{row.oldValue}</TableCell>
              <TableCell>{row.newValue}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default FireFloaterChangesTable;